<template>
  <div class="blog-article-link">
    <div
      class="img-cover"
      :style="`background-image: url(${article.cover})`"
    ></div>
    <div class="article-body">
      <h5>{{ article.title }}</h5>
      <div class="flex-fill"></div>
      <button class="btn btn-light btn-block" @click="openArticle">
        Saiba mais
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    article: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    openArticle() {
      this.$emit("open-article", this.article);
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-article-link {
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  .img-cover {
    width: 100%;
    height: 0;
    padding-bottom: 50%;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    border-radius: 8px 8px 0 0;
    margin-bottom: 8px;
  }
  .article-body {
    flex: 1;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: space-between;
    button {
      font-size: 16px;
    }
  }
}
</style>
